import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

export enum DispoEpargneValidatorKey {
  interdit = 'dispoEpargneInterdit',
}

const dataKey = 'disponibiliteEpargne';

export class DispoEpargneValidatorsFactory {
  static getValidator(validatorKey: string, config: FormConfigService): ValidatorFn | undefined {
    switch (validatorKey) {
      case DispoEpargneValidatorKey.interdit:
        return dispoEpargneInterdit(config);
      default:
        return undefined;
    }
  }
}

export function dispoEpargneInterdit(config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === dataKey)
      ?.validators?.find(validator => validator.validatorKey === DispoEpargneValidatorKey.interdit);
    if (!validatorConfig) {
      return null;
    }
    const forbiddenChoicesEnums = validatorConfig?.parameters
      ?.find(parameter => parameter.key === 'codes')
      ?.value?.toString()
      ?.split(',');

    if (
      forbiddenChoicesEnums &&
      Array.isArray(forbiddenChoicesEnums) &&
      forbiddenChoicesEnums.length &&
      control instanceof FieldFormControl
    ) {
      const controlSelectedEnum = control?.value?.toString();
      if (control.value !== undefined && controlSelectedEnum) {
        if (forbiddenChoicesEnums.includes(controlSelectedEnum)) {
          return {
            custom: 'true',
            code: DispoEpargneValidatorKey.interdit,
          };
        }
      }
    }

    return null;
  };
}
